import React from "react";

const Title = ({ sliderInfo }) => {
  const { aciklama, aciklama2 } = sliderInfo?.[0] || {};
  return (
    <section className="relative flex items-center justify-center gap-15 mt-4 sm:mt-10 md:mt-[76px] z-20">
      <h1 className="font-bold sm:text-left text-center leading-7 w-52 sm:w-64 lg:w-[338px] lg:leading-12 text-2xl sm:text-3xl lg:text-4xll">
        {aciklama}
      </h1>
      <p className="hidden sm:block w-[280px] font-medium text-lbase leading-5.5">
        {aciklama2}
      </p>
    </section>
  );
};

export default Title;
